import { useEffect, useState } from "react";
import { subscribeAccessDenied } from "@/lib/accessDenied";

interface ToastState {
  id: number;
  message: string;
}

const AUTO_HIDE_MS = 4000;

/**
 * Thông báo nhỏ khi người dùng bị chặn truy cập một trang.
 *
 * Nằm trong khung ứng dụng nên không mất đi khi bị chuyển hướng. Mỗi lần bị
 * chặn lại thì đồng hồ tự ẩn được đếm lại từ đầu.
 */
export default function AccessDeniedToast() {
  const [toast, setToast] = useState<ToastState | null>(null);

  useEffect(
    () =>
      subscribeAccessDenied((message) =>
        setToast({ id: Date.now(), message })
      ),
    []
  );

  useEffect(() => {
    if (!toast) return;
    const timer = window.setTimeout(() => setToast(null), AUTO_HIDE_MS);
    return () => window.clearTimeout(timer);
  }, [toast]);

  if (!toast) return null;

  return (
    <div className="pointer-events-none fixed inset-x-0 bottom-6 z-[60] flex justify-center px-4">
      <div
        role="status"
        aria-live="polite"
        className="animate-page-fade pointer-events-auto flex max-w-md items-center gap-3 rounded-lg border border-accent-300 bg-white px-4 py-3"
      >
        <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-accent-100 text-accent-700">
          <i className="ri-lock-2-line text-base" />
        </span>
        <p className="min-w-0 text-sm font-medium text-foreground-900">
          {toast.message}
        </p>
        <button
          type="button"
          onClick={() => setToast(null)}
          aria-label="Đóng thông báo"
          className="flex h-7 w-7 shrink-0 cursor-pointer items-center justify-center rounded-md text-foreground-500 transition-colors hover:bg-background-100 hover:text-foreground-900"
        >
          <i className="ri-close-line text-base" />
        </button>
      </div>
    </div>
  );
}